import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContractComponent } from './contract.component';
import { ContractListComponent } from './contract-list/contract-list.component';
import { ContractRequestComponent } from './contract-request/contract-request.component';
import { ContractPreviewComponent } from './contract-preview/contract-preview.component';
import { ContractDetailsComponent } from './contract-details/contract-details.component';

const routes: Routes = [{
  path:'',
  component:ContractComponent,
  children:[
    {path:'',component:ContractListComponent},
    {path:'request',component:ContractRequestComponent},
    {path:'request/:uuid',component:ContractRequestComponent},
    {path:'preview/:uuid',component:ContractPreviewComponent},
    {path:'details/:uuid',component:ContractDetailsComponent},
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContractRoutingModule { }
